export function joinDataTestId(...parts: string[]) {
  return parts.join("/");
}
